import React, { useCallback, useEffect, useState } from 'react'
import styles from '../../css/style.module.css'
import { AddCategory, DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { formatDateTime } from '../../utils/utils';
import { deleteApi, getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import HOC from '../../components/HOC/HOC'
import { Link } from 'react-router-dom';
import Pagination from '../../components/Pagination/Pagination';
import StatusToggle from '../../components/StatusToggle/StatusToggle';



import img from '../../assest/loading1.gif'

import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";


const columns = ['S.no', 'Name', 'Image', 'Created At', 'Updated At', 'Status', 'Action'];




const Category = () => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [search, setSearch] = useState('')
    const [pagination, setPagination] = useState({
        limit: 5,
        totalPages: 1,
        page: 1,
        hasPrevPage: false,
        hasNextPage: false,
    });

    const fetchData = useCallback(async () => {
        await getApi(endPoints.getallcategoryPaginate(pagination.page, pagination.limit, search), {
            setResponse: setCategories,
            setLoading,
            errorMsg: 'Failed to fetch Category!'
        });
    }, [pagination.page, pagination.limit, search]);

    useEffect(() => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            totalPages: categories?.data?.totalPages,
            hasPrevPage: categories?.data?.hasPrevPage,
            hasNextPage: categories?.data?.hasNextPage,
        }));
    }, [categories]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);




    const handleDelete = async () => {
        if (!selectedCategory) return;

        await deleteApi(endPoints.deletecategory(selectedCategory), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete category!'
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);
    };


    const handleToggleStatus = async (item, nextHidden) => {
        await putApi(
            endPoints.updatecategorystatus(item._id),
            { isHidden: nextHidden },
            {
                setLoading,
                successMsg: nextHidden
                    ? 'Category hidden successfully!'
                    : 'Category shown successfully!',
                errorMsg: 'Failed to update category status!',
            }
        );
        fetchData();
    };

    const openDeleteModal = (categoryId) => {
        setSelectedCategory(categoryId);
        setShowDeleteModal(true);
    };

    const openEditModal = (category) => {
        setSelectedCategory(category);
        setEditMode(true);
        setShowAddModal(true);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
    };


    const routeMapping = {
        Category: "/job-management/category",
        SubCategory: "/job-management/subcategory",
        "SubCategory Child": "/job-management/subcategory-child",
        Product: "/job-management/products",
    };


    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="Delete Category"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <AddCategory
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                Category={fetchData}
                data={selectedCategory}
                edit={editMode}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Job Management</h6>
                        <div className={styles.searchbarnav}>
                            <IoSearchSharp color='#8A8A8A' size={20} />
                            <input
                                type="search"
                                placeholder="Search"
                                value={search}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={() => {
                            setEditMode(false);
                            setShowAddModal(true);
                        }}>
                            <FaPlus color='#FFFFFF' />
                            <p>Create Category</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Category', 'SubCategory', 'SubCategory Child', 'Product'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'Category'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" className={styles.loadingCell}>
                                            <img src={img} alt="Loading..." width={100} height={100} />
                                        </td>
                                    </tr>
                                ) : categories?.data?.docs?.length ? (
                                    categories?.data?.docs?.map((item, index) => (
                                        <tr key={item?._id} className={styles.tableRow}>
                                            <td>{index + 1}</td>
                                            <td>{item?.name}</td>
                                            <td><img src={item?.image} alt={item?.name} className={styles.imgtable} /></td>
                                            <td>{formatDateTime(item?.createdAt)}</td>
                                            <td>{formatDateTime(item?.updatedAt)}</td>
                                            <td>
                                                <StatusToggle
                                                    isHidden={item?.isHidden}
                                                    onChange={(next) => handleToggleStatus(item, next)}
                                                />
                                            </td>
                                            <td>
                                                <div className={styles.tableaction}>
                                                    <FaRegEdit size={20} onClick={() => openEditModal(item)} style={{ cursor: "pointer", color: "#e9b44a" }} />
                                                    <RiDeleteBin6Line
                                                        size={20}
                                                        onClick={() => openDeleteModal(item._id)}
                                                        style={{ cursor: "pointer", color: "#d9534f" }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className={styles.noDataCell}>No data available.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        limit={pagination.limit}
                        totalPages={pagination.totalPages}
                        page={pagination.page}
                        hasPrevPage={pagination.hasPrevPage}
                        hasNextPage={pagination.hasNextPage}
                        onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
                    />
                </div>
            </div>
        </>
    )
}

export default HOC(Category)
